import { z } from 'zod';

import { DrawId } from '../BrandedIds';
import { DrawInput } from '../loan/Draw';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CreateDrawEvent = BaseLoanEvent.extend({
  type: z.literal('createDraw'),
  draw: DrawInput,
  comment: z.string().optional(),
  drawId: DrawId.optional(),
  includeAllDrawsInMonth: z.boolean().optional(),
});
export type CreateDrawEvent = z.infer<typeof CreateDrawEvent>;
